import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/** Allowed lengths for Brazilian boleto linha digitável (digits only). */
export const digitableLineAllowedLengths = [44, 47, 48] as const;

/** Strip everything except digits. */
export function normalizeDigitableLine(value: unknown): string {
  return String(value ?? '').replace(/\D/g, '');
}

export function isValidDigitableLineLength(digits: string): boolean {
  return (digitableLineAllowedLengths as readonly number[]).includes(
    digits.length,
  );
}

/** Validator: required digits-only linha digitável of length 44, 47, or 48. */
export function validateDigitableLine(
  control: AbstractControl,
): ValidationErrors | null {
  const raw = control.value;
  if (raw === null || raw === undefined || String(raw).trim() === '') {
    return {required: true};
  }
  const digits = normalizeDigitableLine(raw);
  if (!isValidDigitableLineLength(digits)) {
    return {invalidDigitableLine: true};
  }
  return null;
}

/** Factory that also writes normalized digits back when valid (optional). */
export function digitableLineValidator(): ValidatorFn {
  return validateDigitableLine;
}
